/* eslint-disable import/extensions */
import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { useInfiniteQuery } from 'react-query';

import { crmModels } from '..';

export function useGetChatFlow({ type, enabled }: { type?: 'create' | 'settings'; enabled: boolean }) {
  const dataType = useAppSelector(({ robotoCallReducer }) => robotoCallReducer.audience?.dataType);

  return useInfiniteQuery<Pagination<crmModels.IChatFlowModel>>({
    queryKey: ['chat-flow', dataType],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await $api.post(`/v1/chat-flow/filter`, {
        type: type === 'create' ? 'CALL' : 'MESSAGE',
        page: pageParam,
        size: 10,
        ...(type === 'create' && { dataType })
      });

      return res.data.data;
    },
    getNextPageParam: (lastPage, page) => {
      if (page.length < lastPage?.totalPages) {
        return page.length + 1;
      }
      return undefined;
    },
    enabled
  });
}
